import React from 'react';
import { Box, Text, Tooltip } from '@zillow/constellation-10';

import type { OutputCardProps } from './../types';

const OutputCard: React.FC<React.PropsWithChildren<React.PropsWithChildren<OutputCardProps>>> = ({
  title,
  tooltipText,
  value,
}: OutputCardProps) => {
  return (
    <Box
      css={{
        padding: '200',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        // oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 120px` falls between `2600` (104px) and `3600` (144px) on the numeric sizes scale
        height: '120px',
        flex: 1,
        marginRight: '600',
        borderRadius: '5px',
        backgroundColor: 'bg.softer',

        '&:last-of-type': {
          marginRight: 0,
        },
      }}
    >
      <Text textStyle="body-sm" asChild>
        <h4>
          {title} <Tooltip content={tooltipText} />
        </h4>
      </Text>
      <Text textStyle="heading-sm" asChild>
        <strong>{value}</strong>
      </Text>
    </Box>
  );
};

export default OutputCard;
